var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-checkbox",class:{
    'compare-checkbox--active': _vm.activeState,
    'compare-checkbox--disabled': _vm.disabledState,
    'compare-checkbox--size-small': _vm.size === 'small',
  }},[_c('FormCheckbox',{attrs:{"field":_vm.checkboxField,"label":_vm.$t('common.compare'),"value":_vm.value,"disabled":_vm.disabledState},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }